// extracted by mini-css-extract-plugin
export default {"adHowTo":"hF49qe"};